<template>
  <v-sheet class="fill-height" tile color="white">
    <v-container fluid>
      <v-text-field
        hide-details
        v-model="search"
        prepend-inner-icon="search"
        dense
        outlined
        placeholder="Find Store"
      >
        <template v-slot:append-outer> </template>
      </v-text-field>
      <vue-custom-scrollbar :settings="settings" class="scroll-area">
        <v-card
          :class="['title-card', active('all') ? 'active' : '']"
          flat
          tile
          @click="toAllStores"
        >
          <div class="card-content">
            <v-btn depressed small fab color="primary">
              <v-icon>shopping_bag</v-icon>
            </v-btn>
            <span class="mx-2">All Stores</span>
          </div>
        </v-card>
        <v-spacer style="height: 70px"></v-spacer>
        <transition-group
          name="scroll-y-transition"
          tag="div"
          class="search-transition"
        >
          <div
            :key="single_store.id"
            @click="toDetails(single_store.id)"
            v-for="single_store in allStoresInCurrentBrand"
          >
            <v-card
              :class="['store-item', active(single_store.id) ? 'active' : '']"
              tile
              flat
              v-if="
                single_store.name.toLowerCase().includes(search.toLowerCase())
              "
            >
              <v-list-item-avatar class="avatar small">
                <SpotS3Image :image-path="brand.image"></SpotS3Image>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title>{{ single_store.name }}</v-list-item-title>
                <v-list-item-subtitle>
                  {{ single_store.address }}</v-list-item-subtitle
                >
              </v-list-item-content>
            </v-card>
          </div>
        </transition-group>
      </vue-custom-scrollbar>
    </v-container>
  </v-sheet>
</template>

<script>
import { mapGetters } from "vuex";
import vueCustomScrollbar from "vue-custom-scrollbar";
import "vue-custom-scrollbar/dist/vueScrollbar.css";
import StoreTile from "../Stores/StoreTile";
import { PAGE_IDS } from "../utils/constants";
import SpotS3Image from "../Pages/SpotS3Image";

export default {
  methods: {
    active(id) {
      if (this.$route.path == "brand/dashboard/all") {
        return true;
      } else {
        return this.$route.path.includes(id);
      }
    },
    toDetails(id) {
      let path = `/brand/dashboard/${id}`;
      if (this.$route.path !== path) {
        this.$router.push({
          name: PAGE_IDS.BRAND_DASHBOARD_SINGLE_STORE,
          params: { store_id: id }
        });
      }
    },
    toAllStores() {
      if (this.$route.path !== "/brand/dashboard/all") {
        this.$router.push({ name: PAGE_IDS.BRAND_DASHBOARD });
      }
    },

    
  },
  
  components: {
    SpotS3Image,
    StoreTile,
    vueCustomScrollbar
  },
  name: "DashboardStoreSearch",
  data: () => ({
    search: "",
    settings: {
      swipeEasing: true,
      suppressScrollY: false,
      suppressScrollX: true,
      wheelPropagation: false
    }
  }),
  computed: {
    ...mapGetters([
      "getBrandById",
      "getCurrentBrand",
      "allStoresInCurrentBrand"
    ]),
    brand() {
      return this.getBrandById(this.getCurrentBrand);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~vuetify/src/styles/settings/_variables";

.scroll-area {
  margin: 0 -20px;
  padding: 1rem;
  position: relative;

  .store-item {
    cursor: pointer;
    border-radius: 8px;
    display: grid;
    grid-template-columns: auto 1fr;

    &.active {
      background-color: #f5f9fd !important;

      .v-list-item__title {
        color: var(--v-primary-base) !important;
      }

      .v-list-item__subtitle {
        color: var(--v-primary-base) !important;
      }
    }
  }

  @media #{map-get($display-breakpoints, 'md-and-down')} {
  }

  .title-card {
    color: black;
    padding: 1rem 2rem;
    font-size: 16px;
    font-weight: 600;
    letter-spacing: 0.12px;
    position: absolute;
    left: 0;
    right: 0px;
    height: 70px;

    &.active {
      background-color: #f5f9fd !important;
      color: var(--v-primary-base);
    }

    .card-content {
    }
  }

  .search-transition {
  }
}
</style>



// WEBPACK FOOTER //
// src/Elements/DashboardStoreSearch.vue